import React from 'react';
import './features.scss';
import { Container, Typography } from '@material-ui/core';
import FeaturesCarousel from './../features-carousel/features-carousel';

const Features = () => {
  return (
    <div className="App_features" id="Features">
      <Container maxWidth="md">
        <Typography variant="h2">Platform Features </Typography>
        <p>
          Find out more about our latest exciting seafaring loot&nbsp;below.
        </p>
      </Container>
      <FeaturesCarousel />
    </div>
  );
};

export default Features;
